import { SHContainer, SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { SHDividerSkeleton } from "@components/skeletons/design-systems";
import { GroupCarouselSkeleton } from "@components/skeletons/layouts/platform-analysis/GroupCarouselSkeleton";
import { TransferSelectFeatureListSkeleton } from "@components/skeletons/layouts/platform-analysis/TransferSelectFeatureListSkeleton";
import { StepNameSkeleton } from "@components/skeletons/layouts/stepper/StepNameSkeleton";

export const AnalysisFeatureSelectionSkeleton = () => {
  return (
    <SHContainer maxWidth="xl" sx={{ px: { xs: "16px", lg: "200px" } }}>
      <SHStack spacing={3} marginTop={3}>
        <StepNameSkeleton delay={false} />
        <GroupCarouselSkeleton skeletonProps={{ delay: false }} />
        <SHSkeleton width={"100%"} height={"50px"} delay={false} />
        <SHDividerSkeleton delay={false} />
        <TransferSelectFeatureListSkeleton
          skeletonProps={{
            delay: false,
          }}
        />
      </SHStack>
    </SHContainer>
  );
};
